<div class="main-content">
  <nav class="navbar navbar-top navbar-horizontal navbar-expand-md navbar-dark">
    <div class="container px-4">
      <a
        class="navbar-brand"
        routerLinkActive="active"
      >
        <img [src]="imagePath" />
      </a>
      <!-- <button
        class="navbar-toggler"
        type="button"
        (click)="isCollapsed = !isCollapsed"
        aria-controls="sidenav-collapse-main"
      >
        <span class="navbar-toggler-icon"></span>
      </button> -->
      <!-- <div
        class="collapse navbar-collapse"
        [ngbCollapse]="isCollapsed"
        id="sidenav-collapse-main"
      >
        <div class="navbar-collapse-header d-md-none">
          <div class="row">
            <div class="col-6 collapse-brand">
              <a routerLinkActive="active" [routerLink]="['/dashboard']">
                <img [src]="imagePath" />
              </a>
            </div>
            <div class="col-6 collapse-close">
              <button
                type="button"
                class="navbar-toggler"
                (click)="isCollapsed = !isCollapsed"
              >
                <span></span>
                <span></span>
              </button>
            </div>
          </div>
        </div>
      </div>  -->
    </div>
  </nav>
  <router-outlet></router-outlet>
</div>